import { cn } from '../../lib/utils';

/**
 * Card component matching design system specifications
 * Uses design system surface colors, radius, border, and shadow
 */
export function Card({ children, className, ...props }) {
  return (
    <div
      className={cn(
        'bg-[var(--ds-surface-panel)]',
        'border border-[var(--ds-border-subtle)]',
        'rounded-[var(--ds-radius-lg)]',
        'shadow-[var(--ds-shadow-card)]',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * Card Header component
 */
export function CardHeader({ children, className, ...props }) {
  return (
    <div
      className={cn('flex items-center justify-between p-5 pb-4', className)}
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * Card Title component (h2 styling)
 */
export function CardTitle({ children, className, ...props }) {
  return (
    <h2
      className={cn(
        'text-h2 text-[var(--ds-text-primary)] font-semibold',
        className
      )}
      {...props}
    >
      {children}
    </h2>
  );
}

/**
 * Card Description component (meta text)
 */
export function CardDescription({ children, className, ...props }) {
  return (
    <p
      className={cn(
        'text-meta text-[var(--ds-text-muted)] mt-1',
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
}

/**
 * Card Content component (body with padding)
 */
export function CardContent({ children, className, ...props }) {
  return (
    <div
      className={cn('p-5 pt-4', className)}
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * Card Footer component
 */
export function CardFooter({ children, className, ...props }) {
  return (
    <div
      className={cn(
        'flex items-center p-5 pt-4 border-t border-[var(--ds-border-divider)]',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

